
import { request } from './';

const fetch = async () => {
    const result = await request('/areas/fetch', {});
    return result.data;
};

export default { fetch };
